module.exports = __webpack_public_path__ + "img/broccoli_pizza.1b472cb6.jpg";